// import React from 'react';
import { createPortal } from 'react-dom';
import { useContext } from "react";
import AuthContext from './AuthContext';

export default function FullscreenOverlay({children, notify, portal}) {
  const {auth, setAuth, login, logout} = useContext(AuthContext);
  
  // const portalRoot = document.getElementById('react-portal-overlay-root');
  const portalRoot = document.getElementById(portal);
  const close = () => {
    // const data = { confirmed: true, timestamp: Date.now() }; // example data
    logout();
    notify(false); // emit data to parent
  };
  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1,
        backgroundColor: 'white',
        color: 'black',
        display: 'grid',
        alignItems: 'center',        /* center all grid items vertically */
        justifyItems: 'center',      /* center all horizontally */
        overflowY: 'scroll',
        // height: 300px,
        // border: 1px solid gray;
      }}
    >
        <button 
            id = "x"
            style={{
                position: 'absolute',
                background: '#e48c80',
                color: 'white',
                right: '20px',
                top: '20px'
            }}
            onClick={close}
        >
            X
        </button>
        {children}
     </div>,
    portalRoot
  );
};